/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Group, rem, type GroupProps } from '@mantine/core';

import type { PropsWithChildren } from '@fai/util/types';

export function FooterlessModalFooter({ children, ...props }: PropsWithChildren<GroupProps>) {
  return (
    <Group justify="flex-end" gap={rem(16)} pt={rem(20)} pb={rem(4)} {...props}>
      {children}
    </Group>
  );
}
